import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { env } from '../config/env';
import fr from './locales/fr_new';
import en from './locales/en';
import enUS from './locales/en-US';
import es from './locales/es';
import de from './locales/de';
import it from './locales/it';
import { initTranslationMonitor } from './translation-monitor';

// Importer les traductions des pages françaises
import frAccount from './locales/fr/pages/account';
import frBudget from './locales/fr/pages/budget';
import frEvents from './locales/fr/pages/events';
import frGuests from './locales/fr/pages/guests';
import frLegal from './locales/fr/pages/legal';
import frAchievements from './locales/fr/pages/achievements';
import frVendors from './locales/fr/pages/vendors';
import frAuth from './locales/fr/pages/auth';
import frTasks from './locales/fr/pages/tasks';
import frSubscription from './locales/fr/pages/subscription';
import frTimeline from './locales/fr/pages/timeline';
import frProfile from './locales/fr/pages/profile';
import frSettings from './locales/fr/pages/settings';
import frInvitation from './locales/fr/pages/invitation';
import frDashboard from './locales/fr/pages/dashboard';
import frGuest from './locales/fr/pages/guest';
import frCommon from './locales/fr/pages/common';
import frDebug from './locales/fr/debug';
import frTaskTemplates from './locales/fr/taskTemplates';
import frRsvp from './locales/fr/pages/rsvp';
import frNotifications from './locales/fr/pages/notifications';

// Importer les traductions des pages anglaises
import enAccount from './locales/en/pages/account';
import enBudget from './locales/en/pages/budget';
import enEvents from './locales/en/pages/events';
import enGuests from './locales/en/pages/guests';
import enLegal from './locales/en/pages/legal';
import enAchievements from './locales/en/pages/achievements';
import enVendors from './locales/en/pages/vendors';
import enAuth from './locales/en/pages/auth';
import enTasks from './locales/en/pages/tasks';
import enSubscription from './locales/en/pages/subscription';
import enTimeline from './locales/en/pages/timeline';
import enProfile from './locales/en/pages/profile';
import enSettings from './locales/en/pages/settings';
import enInvitation from './locales/en/pages/invitation';
import enCommon from './locales/en/pages/common';
import enDebug from './locales/en/debug';
import enDashboard from './locales/en/pages/dashboard';
import enGuest from './locales/en/pages/guest';
import enTaskTemplates from './locales/en/taskTemplates';
import enRsvp from './locales/en/pages/rsvp';
import enNotifications from './locales/en/pages/notifications';

// Importer les traductions des pages allemandes
import deAccount from './locales/de/pages/account';
import deBudget from './locales/de/pages/budget';
import deEvents from './locales/de/pages/events';
import deGuests from './locales/de/pages/guests';
import deLegal from './locales/de/pages/legal';
import deAchievements from './locales/de/pages/achievements';
import deVendors from './locales/de/pages/vendors';
import deAuth from './locales/de/pages/auth';
import deTasks from './locales/de/pages/tasks';
import deSubscription from './locales/de/pages/subscription';
import deTimeline from './locales/de/pages/timeline';
import deProfile from './locales/de/pages/profile';
import deSettings from './locales/de/pages/settings';
import deInvitation from './locales/de/pages/invitation';
import deCommon from './locales/de/pages/common';
import deDebug from './locales/de/debug';
import deDashboard from './locales/de/pages/dashboard';
import deGuest from './locales/de/pages/guest';
import deTaskTemplates from './locales/de/taskTemplates';
import deRsvp from './locales/de/pages/rsvp';
import deNotifications from './locales/de/pages/notifications';

// Importer les traductions des pages espagnoles
import esAccount from './locales/es/pages/account';
import esBudget from './locales/es/pages/budget';
import esEvents from './locales/es/pages/events';
import esGuests from './locales/es/pages/guests';
import esLegal from './locales/es/pages/legal';
import esAchievements from './locales/es/pages/achievements';
import esAuth from './locales/es/pages/auth';
import esProfile from './locales/es/pages/profile';
import esTasks from './locales/es/pages/tasks';
import esSubscription from './locales/es/pages/subscription';
import esTimelinePages from './locales/es/pages/timeline';
import esVendorsPages from './locales/es/pages/vendors';
import esSettings from './locales/es/pages/settings';
import esInvitation from './locales/es/pages/invitation';
import esCommon from './locales/es/pages/common';
import esDebug from './locales/es/debug';
import esDashboard from './locales/es/pages/dashboard';
import esGuest from './locales/es/pages/guest';
import esTaskTemplates from './locales/es/taskTemplates';
import esRsvp from './locales/es/pages/rsvp';
import esNotifications from './locales/es/pages/notifications';

// Importer les traductions des pages italiennes
import itAccount from './locales/it/pages/account';
import itBudget from './locales/it/pages/budget';
import itEvents from './locales/it/pages/events';
import itGuests from './locales/it/pages/guests';
import itLegal from './locales/it/pages/legal';
import itAchievements from './locales/it/pages/achievements';
import itAuth from './locales/it/pages/auth';
import itProfile from './locales/it/pages/profile';
import itTasks from './locales/it/pages/tasks';
import itSubscription from './locales/it/pages/subscription';
import itTimelinePages from './locales/it/pages/timeline';
import itVendorsPages from './locales/it/pages/vendors';
import itSettings from './locales/it/pages/settings';
import itInvitation from './locales/it/pages/invitation';
import itCommon from './locales/it/pages/common';
import itDebug from './locales/it/debug';
import itDashboard from './locales/it/pages/dashboard';
import itGuest from './locales/it/pages/guest';
import itTaskTemplates from './locales/it/taskTemplates';
import itRsvp from './locales/it/pages/rsvp';
import itNotifications from './locales/it/pages/notifications';

// Importer les autres traductions pour EN, DE (déjà existantes)
import enTheme from './locales/en/theme';

// Conservé pour compatibilité mais remplacé par les versions pages pour ES/IT
// import esTimeline from './locales/es/timeline';
// import esVendors from './locales/es/vendors';
import esTheme from './locales/es/theme';

import deTheme from './locales/de/theme';

// import itTimeline from './locales/it/timeline';
// import itVendors from './locales/it/vendors';
import itTheme from './locales/it/theme';

// Fonction pour détecter la langue du système
const getSystemLanguage = (): string => {
  const browserLang = navigator.language?.split('-')[0] || 'fr';
  const supportedLanguages = ['fr', 'en', 'en-US', 'es', 'de', 'it'];
  return supportedLanguages.includes(browserLang) ? browserLang : 'fr';
};

// Fonction pour récupérer la langue sauvegardée
const getSavedLanguage = () => {
  return localStorage.getItem('language');
};

// Configuration de i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: {
        translation: fr,
        common: frCommon,
        account: frAccount,
        budget: frBudget,
        events: frEvents,
        guests: frGuests,
        legal: frLegal,
        achievements: frAchievements,
        vendors: frVendors,
        auth: frAuth,
        tasks: frTasks,
        subscription: frSubscription,
        timeline: frTimeline,
        profile: frProfile,
        settings: frSettings,
        invitation: frInvitation,
        dashboard: frDashboard,
        notifications: frNotifications,
        guest: frGuest,
        debug: frDebug,
        taskTemplates: frTaskTemplates,
        rsvp: frRsvp
      },
      en: {
        translation: en,
        common: enCommon,
        dashboard: enDashboard,
        guest: enGuest,
        account: enAccount,
        budget: enBudget,
        events: enEvents,
        guests: enGuests,
        legal: enLegal,
        achievements: enAchievements,
        vendors: enVendors,
        auth: enAuth,
        tasks: enTasks,
        subscription: enSubscription,
        timeline: enTimeline,
        profile: enProfile,
        settings: enSettings,
        invitation: enInvitation,
        theme: enTheme,
        notifications: enNotifications,
        debug: enDebug,
        taskTemplates: enTaskTemplates,
        rsvp: enRsvp
      },
      'en-US': {
        translation: enUS,
        common: enUS.common,
        dashboard: enDashboard,
        guest: enGuest,
        account: enAccount,
        budget: enUS.budget,
        events: enEvents,
        guests: enGuests,
        legal: enLegal,
        achievements: enAchievements,
        vendors: enVendors,
        auth: enAuth,
        tasks: enTasks,
        subscription: enUS.subscription,
        timeline: enTimeline,
        profile: enProfile,
        settings: enSettings,
        invitation: enInvitation,
        theme: enTheme,
        notifications: enNotifications,
        debug: enDebug,
        taskTemplates: enTaskTemplates,
        rsvp: enRsvp
      },
      es: {
        translation: es,
        common: esCommon,
        dashboard: esDashboard,
        guest: esGuest,
        account: esAccount,
        budget: esBudget,
        events: esEvents,
        guests: esGuests,
        legal: esLegal,
        achievements: esAchievements,
        auth: esAuth,
        profile: esProfile,
        tasks: esTasks,
        subscription: esSubscription,
        timeline: esTimelinePages,
        vendors: esVendorsPages,
        settings: esSettings,
        invitation: esInvitation,
        theme: esTheme,
        notifications: esNotifications,
        debug: esDebug,
        taskTemplates: esTaskTemplates,
        rsvp: esRsvp
      },
      de: {
        translation: de,
        common: deCommon,
        dashboard: deDashboard,
        guest: deGuest,
        account: deAccount,
        budget: deBudget,
        events: deEvents,
        guests: deGuests,
        legal: deLegal,
        achievements: deAchievements,
        vendors: deVendors,
        auth: deAuth,
        tasks: deTasks,
        subscription: deSubscription,
        timeline: deTimeline,
        profile: deProfile,
        settings: deSettings,
        invitation: deInvitation,
        theme: deTheme,
        notifications: deNotifications,
        debug: deDebug,
        taskTemplates: deTaskTemplates,
        rsvp: deRsvp
      },
      it: {
        translation: it,
        common: itCommon,
        dashboard: itDashboard,
        guest: itGuest,
        account: itAccount,
        budget: itBudget,
        events: itEvents,
        guests: itGuests,
        legal: itLegal,
        achievements: itAchievements,
        auth: itAuth,
        profile: itProfile,
        tasks: itTasks,
        subscription: itSubscription,
        timeline: itTimelinePages,
        vendors: itVendorsPages,
        settings: itSettings,
        invitation: itInvitation,
        theme: itTheme,
        notifications: itNotifications,
        debug: itDebug,
        taskTemplates: itTaskTemplates,
        rsvp: itRsvp
      }
    },
    lng: getSavedLanguage() || getSystemLanguage() || 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    returnObjects: true,
    // Activer le mode debug pour voir les problèmes de traduction dans la console
    debug: env.DEV,
    // Activer les namespaces
    ns: [
      'translation',
      'common',
      'account',
      'budget',
      'events',
      'guests',
      'legal',
      'achievements',
      'vendors',
      'auth',
      'tasks',
      'subscription',
      'timeline',
      'profile',
      'settings',
      'dashboard',
      'guest',
      'theme',
      'invitation',
      'notifications',
      'debug'
    ],
    defaultNS: 'translation',
    load: 'languageOnly',
    preload: ['fr', 'en', 'en-US']
  })
  .then(() => {
    // Initialiser le moniteur de traduction après l'initialisation de i18next
    if (env.DEV) {
      initTranslationMonitor();
    }
  });

// Fonction pour changer la langue
export const changeLanguage = (language: string) => {
  i18n.changeLanguage(language).then(() => {
    localStorage.setItem('language', language);
    // // // // // // // // console.log(`Langue changée pour : ${language}`);
  }).catch(err => {
    console.error('Erreur lors du changement de langue:', err);
  });
};

export default i18n;
